import { PrismicRichTextFieldType, PrismicFluidImageField, PrismicImageField } from '../types';
import { SupportedPrismicSlicesEnum } from '../enums';

export enum ImageTypes {
    fullscreen = 'Full screen',
    boxed = 'Boxed',
    two_images = 'Two images',
}

export type VisualImages = {
    images: VisualImage[];
};

export type VisualImage = {
    visual_image: PrismicImageField;
    visual_imageSharp: PrismicFluidImageField;
    visual_image_atl: PrismicRichTextFieldType;
    visual_image_description: PrismicRichTextFieldType;
};

export type VisualProps = {
    slice: {
        type: SupportedPrismicSlicesEnum.visual;
        primary: {
            visual_image_type: ImageTypes;
        };
        fields: VisualImage[];
    };
};
